import { useEffect, useState } from 'react';
//@ts-ignore
import InfiniteScroll from 'react-infinite-scroller';
import { Box } from '@mui/material';
import * as prismic from '@prismicio/client';

import { createClient } from '../../prismicio';
import theme from 'src/style-system/theme';
import Footer from '@components/Footer';
import PageLoader from '@components/PageLoader';
import PlanBanner from '@components/PlanBanner';
import useEffectExcludingMount from '@utils/useEffectExcludingMount';
import BackToTop from '@public/assets/svg/BackToTop.svg';

import HeroSection from './HeroSection';
import MealCardSection from './MealCardSection';
import TabSection, { tabContent } from './TabSection';

interface IBlogPage {
  pages: any;
}

const BlogPage = ({ pages }: IBlogPage) => {
  const [headerIndex, setHeaderIndex] = useState<number>(0);
  const [pageData, setPageData] = useState<any>(pages);
  const [itemCount, setItemCount] = useState<number>(20);

  const client = createClient();

  const handleBackToTop = () => {
    const element = document.getElementById('blog-page-infinite-scroll');
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const getPages = async ({
    type,
    pageSize,
  }: {
    type: string;
    pageSize: number;
  }) => {
    let pages: any = null;

    if (type === 'All') {
      pages = await client.get({
        page: 1,
        pageSize: pageSize,
        predicates: prismic.predicate.any('document.type', ['page', 'story']),
        orderings: {
          field: 'document.first_publication_date',
          direction: 'desc',
        },
      });
    } else {
      pages = await client.getByType(type, {
        page: 1,
        pageSize: pageSize,
        orderings: {
          field: 'document.first_publication_date',
          direction: 'desc',
        },
      });
    }
    if (pages) {
      setPageData(pages);
      setItemCount(pageSize);
    }
  };

  useEffectExcludingMount(() => {
    const tab = tabContent?.find((item) => item.id === headerIndex);
    if (tab) {
      setPageData({});
      getPages({ type: tab.name, pageSize: 20 });
    }
  }, [headerIndex]);

  const fetchItems = (size: any) => {
    const tab = tabContent?.find((item) => item.id === headerIndex);
    if (tab) {
      getPages({ type: tab.name, pageSize: 20 * (size + 1) });
    }
  };

  return (
    <>
      <HeroSection />
      <TabSection headerIndex={headerIndex} setHeaderIndex={setHeaderIndex} />
      <InfiniteScroll
        id="blog-page-infinite-scroll"
        pageStart={0}
        loadMore={fetchItems}
        hasMore={itemCount <= pageData?.total_results_size}
        loader={<PageLoader height="70px" />}
      >
        <MealCardSection pages={pageData} />
      </InfiniteScroll>
      <Box
        onClick={handleBackToTop}
        sx={{
          backgroundColor: 'whitePepper.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '0 25px 75px',
          cursor: 'pointer',

          [theme.breakpoints.down('md')]: {
            padding: '0 25px 50px',
          },
        }}
      >
        <BackToTop />
      </Box>
      <PlanBanner isSmallPadding />
      <Footer />
    </>
  );
};

export default BlogPage;
